import { has } from "lodash";

export const checkIsGroupBooking = (selectedUser: any, isGrouped: boolean = false) => {
  // replace it with
  // selectedUser ? !isBulkSelectOption(selectedUser) : true;
  // after merge back
  const isBulkSelect = selectedUser ? has(selectedUser, "search_id") : false;
  const isGroupBooking = isGrouped;

  return isGroupBooking || isBulkSelect;
};
